import { useRef, useEffect, useState } from 'react';

const clients = [
  { category: '방송', name: 'KBS' },
  { category: '방송', name: 'JTBC' },
  { category: 'OTT', name: 'Netflix Korea' },
  { category: 'OTT', name: 'Wavve' },
];

export default function Clients() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const handleContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.querySelector('#contact');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Clients Section */}
      <section id="clients" className="w-full bg-[#f5f1ed] py-24 px-10 md:px-20">
        <div className="max-w-screen-xl mx-auto">

          {/* Centered Header */}
          <div className="text-center mb-14">
            <p className="font-sans-kr text-[11px] tracking-[0.3em] uppercase text-[#aaa] mb-4">
              Clients &amp; Partners
            </p>
            <p className="font-sans-kr text-[15px] text-[#555] font-light">
              방송, 플랫폼, 글로벌 브랜드와 함께 일해왔습니다
            </p>
          </div>

          {/* Client Cards */}
          <div
            ref={ref}
            className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#ddd] border border-[#ddd]"
          >
            {clients.map((client, i) => (
              <div
                key={client.name}
                className={`flex flex-col items-center justify-center py-12 px-8 bg-white transition-all duration-700 ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <p className="font-sans-kr text-[10px] tracking-[0.25em] uppercase text-[#bbb] mb-3">
                  {client.category}
                </p>
                <p className="font-sans-kr text-xl font-light text-[#1a1a1a] tracking-wide">
                  {client.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="w-full px-10 md:px-20 py-10 bg-[#f5f1ed]">
        <div className="max-w-screen-xl mx-auto">
          <div
            className="relative w-full overflow-hidden"
            style={{ minHeight: '220px' }}
          >
            {/* Background Image */}
            <img
              src="https://public.readdy.ai/ai/img_res/9e3b47d8915449fc90a8aa1b02824ac4.jpg"
              alt="Film production crew"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/55" />

            {/* Content */}
            <div className="relative z-10 flex items-center justify-between px-14 py-16 h-full">
              <div>
                <p className="font-sans-kr text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
                  Next Project
                </p>
                <h3 className="font-korean-serif text-[1.9rem] md:text-[2.4rem] text-white font-light leading-snug">
                  함께 만들어갈 이야기가 있습니다.
                </h3>
              </div>

              <a
                href="#contact"
                onClick={handleContact}
                className="whitespace-nowrap font-sans-kr text-sm text-white border border-white/70 px-8 py-3.5 hover:bg-white hover:text-[#1a1a1a] transition-all duration-400 cursor-pointer tracking-widest-kr ml-16 shrink-0"
              >
                문의하기
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
